import { useTranslation } from 'react-i18next';
import { Button } from '@ooh/ui/components/button';

interface JobNotFoundStateProps {
  onBackToImport: () => void;
}

export function JobNotFoundState({ onBackToImport }: JobNotFoundStateProps) {
  const { t } = useTranslation('mediaImport');
  return (
    <div
      className="flex flex-col items-center justify-center gap-4 py-20 text-center"
      data-testid="import-job-not-found"
    >
      <div className="space-y-1">
        <p className="font-medium">{t('jobNotFound.title')}</p>
        <p className="body-lg text-muted-foreground max-w-sm">{t('jobNotFound.description')}</p>
      </div>
      <Button size="sm" onClick={onBackToImport}>
        {t('jobNotFound.action')}
      </Button>
    </div>
  );
}
